export const avaliabilityColors = {
    available: "rgba(144, 238, 144, 0.5)",
    reserved: "rgba(255, 165, 0, 0.5)",
    occupied: "rgba(255, 0, 0, 0.5)",
  };